export const CAMPAIGN_STATUS_OPTIONS = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'ERROR'];

export const CAMPAIGN_STATUS_LABELS = {
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
    ERROR: 'Error',
};

export const CAMPAIGN_STATUS_BADGES = {
    PENDING: 'text-bg-info',
    IN_PROGRESS: 'text-bg-primary',
    COMPLETED: 'text-bg-success',
    ERROR: 'text-bg-danger',
};

export const CAMPAIGN_STATUS_ICONS = {
    PENDING: 'bi-hourglass-split',
    IN_PROGRESS: 'bi-arrow-repeat',
    COMPLETED: 'bi-check-circle-fill',
    ERROR: 'bi-exclamation-circle-fill',
};

export const getCampaignStatusKey = (campaign) => {
    if (!campaign) return null;
    if (campaign.status) return campaign.status;
    if (campaign.statusCode != null) {
        return CAMPAIGN_STATUS_OPTIONS[campaign.statusCode];
    }
    return null;
};

export const CampaignStatusBadge = ({ status, statusCode }) => {
    const key = status || (statusCode != null ? CAMPAIGN_STATUS_OPTIONS[statusCode] : null);
    const badgeClass = CAMPAIGN_STATUS_BADGES[key] || 'text-bg-secondary';
    const label = CAMPAIGN_STATUS_LABELS[key] || key || 'Unknown';
    const icon = CAMPAIGN_STATUS_ICONS[key] || 'bi-question-circle';

    return (
        <span className={`badge ${badgeClass} fw-normal`}>
            <i className={`bi ${icon} me-1`}></i>
            {label}
        </span>
    );
};

export const CAMPAIGN_QUEUE_STATUS_LABELS = {
    WAITING: 'Waiting',
    SENT: 'Sent',
    FAILED: 'Failed',
};

export const CAMPAIGN_QUEUE_STATUS_BADGES = {
    WAITING: 'text-bg-info',
    SENT: 'text-bg-success',
    FAILED: 'text-bg-danger',
};

export const CAMPAIGN_QUEUE_STATUS_ICONS = {
    WAITING: 'bi-hourglass-split',
    SENT: 'bi-check-circle-fill',
    FAILED: 'bi-exclamation-circle-fill',
};

export const CampaignQueueStatusBadge = ({ status }) => {
    const label = CAMPAIGN_QUEUE_STATUS_LABELS[status] || status || 'Unknown';
    const badgeClass = CAMPAIGN_QUEUE_STATUS_BADGES[status] || 'text-bg-secondary';
    const icon = CAMPAIGN_QUEUE_STATUS_ICONS[status] || 'bi-question-circle';

    return (
        <span className={`badge ${badgeClass} fw-normal`}>
            <i className={`bi ${icon} me-1`}></i>
            {label}
        </span>
    );
};

export const CAMPAIGN_RESULT_STATUS_LABELS = {
    FAILED: 'Failed',
    UNSUBSCRIBED: 'Unsubscribed',
    SUBSCRIBED_SENT: 'Sent',
    READ: 'Read',
};

export const CAMPAIGN_RESULT_STATUS_BADGES = {
    FAILED: 'text-bg-danger',
    UNSUBSCRIBED: 'text-bg-warning',
    SUBSCRIBED_SENT: 'text-bg-success',
    READ: 'text-bg-primary',
};

export const CAMPAIGN_RESULT_STATUS_ICONS = {
    FAILED: 'bi-x-octagon-fill',
    UNSUBSCRIBED: 'bi-person-fill-slash',
    SUBSCRIBED_SENT: 'bi-send-fill',
    READ: 'bi-eye-fill',
};

export const CampaignResultStatusBadge = ({ status }) => {
    const label = CAMPAIGN_RESULT_STATUS_LABELS[status] || status || 'Unknown';
    const badgeClass = CAMPAIGN_RESULT_STATUS_BADGES[status] || 'text-bg-secondary';
    const icon = CAMPAIGN_RESULT_STATUS_ICONS[status] || 'bi-question-circle';

    return (
        <span className={`badge ${badgeClass} fw-normal`}>
            <i className={`bi ${icon} me-1`}></i>
            {label}
        </span>
    );
};
